(function($) {
    jQuery.fn.tabs = function (htOptions) {
        var defaults = {
            "sActiveClass" : "on",
            "elTabBtn": ">li",
            "elTabPanel": ">div>div",
            "elFilter" : "a",
            "nDefaultIndex" : 0,
            "fnChange" : null
        }, settings = $.extend({}, defaults, htOptions);

        return this.each(function () {
            var welTabcontainer = $(this),
                welTabHeaders = welTabcontainer.find(settings.elTabBtn),
                welTabPanels = welTabcontainer.find(settings.elTabPanel),
                sActiveClass = settings.sActiveClass;

            welTabHeaders.on("click", settings.elFilter, function (e) {
                e.preventDefault();

                var $this = $(this),
                    nTabIdx = welTabHeaders.index($this.parent());

                if ($this.parent().hasClass(sActiveClass)) {
                    return false;
                }

                $this
                    .parent()
                    .addClass(sActiveClass)
                    .siblings()
                    .removeClass(sActiveClass);

                welTabPanels
                    .hide()
                    .eq(nTabIdx)
                    .show();

                if($.isFunction( settings.fnChange )){
                    settings.fnChange.call( this, welTabPanels.eq(nTabIdx) );
                }
            });
        });
    };
})(jQuery);